import type { EditorState } from 'prosemirror-state';
import type { EditorView } from 'prosemirror-view';

import type { MentionServiceInternal } from './mentions-service-internal';
import { MentionNode } from './nodes';
import type { MentionElement, MentionType } from './types';
import { TextNode } from '../basic/nodes';

export class MentionsServicePublic {
  private preferredPickerPositions = [
    <const>{ originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' },
    <const>{ originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
  ];

  constructor(
    private editorView: EditorView,
    private mentionServiceInternal: MentionServiceInternal,
  ) {}

  public mentionsWithSearchOpen(origin: HTMLElement) {
    const { from, to } = this.editorView.state.selection;
    const position = origin.getBoundingClientRect();

    this.mentionServiceInternal.currentOrigin = origin;
    this.mentionServiceInternal.openMentionsList(position, {
      withSearch: true,
      preferredPositions: this.preferredPickerPositions,
      queryChange: (value: string) => {
        const filteredData = this.mentionServiceInternal.filterData(value);
        this.mentionServiceInternal.updateMentionListData(from, to, filteredData);
      },
    });
    this.mentionServiceInternal.updateMentionListData(from, to, this.mentionServiceInternal.data);
  }

  public insertMentionAtSelection(mention: MentionElement): EditorState {
    const { state } = this.editorView;
    const { tr, schema } = state;
    const mentionNode = this.mentionServiceInternal.createMentionNode(schema, mention);
    tr.insert(state.selection.from, [mentionNode, schema.text(' ')]);
    return state.apply(tr);
  }

  public getMentionsFromCurrentDoc() {
    const { state } = this.editorView;
    let mentions: Array<{ id: number; type: MentionType }> = [];
    state.doc.nodesBetween(0, state.doc.content.size, node => {
      if (TextNode.is(node)) return false;
      if (MentionNode.is(node)) {
        const { 'data-id': id, 'data-type': type } = node.attrs;
        mentions = [...mentions, { id, type }];
      }
      return true;
    });

    return mentions;
  }
}
